


















import './KisweDefinitionList.scss'
import { defineComponent } from '@vue/composition-api'
import { DefinitionList } from '@/types/uiComponents'

export default defineComponent({
  name: 'KisweDefinitionList',
  props: {
    definitions: {
      type: Array as () => DefinitionList[],
      required: true
    }
  }
})
